/** C-19: fascia fissa in cima quando il frontend e' compilato con VITE_SANDBOX_BANNER=1 (ambiente di prova, dati finti). */
export const IS_SANDBOX = import.meta.env['VITE_SANDBOX_BANNER'] === '1'

export function SandboxBanner() {
  if (!IS_SANDBOX) return null
  return (
    <div className="md-sandbox-banner" role="status">
      AMBIENTE DI PROVA - dati finti, email e integrazioni spente
    </div>
  )
}
